import * as fromNotifications from "../../../shared-components/store/notifications/notificationsReducer"

/**
 * Return the notifications
 */
export const getNotifications = state => fromNotifications.getNotifications(state.notifications)
